<!-- components/Wishlist.vue -->
<template>
    <section class="flex justify-center items-center">
        <div class="relative w-full max-w-[380px]">
            <!-- Tabs -->
            <div class="flex gap-2 mb-3 overflow-x-auto">
                <Button v-for="tab in tabs" :key="tab" @click="activeTab = tab"
                    unstyled
                    class="px-3 py-1 text-xs font-medium rounded-md border border-[var(--background-btn)] bg-[#FAFAFA0A] text-foreground whitespace-nowrap"
                    :class="{ 'bg-foreground text-[var(--text-gray)]': activeTab === tab }">
                    {{ tab }}
                </Button>
            </div>

            <!-- Wishlist items (2 cards only) -->
            <div class="grid grid-cols-2 gap-3 w-full">
                <div v-for="(item, index) in products.slice(0, 2)" :key="index"
                    class="bg-[var(--background-primary)] border border-[var(--background-btn)] rounded-md px-4 py-2 flex flex-col shadow-sm">
                    <!-- Product image -->
                    <div class="w-full h-28 bg-muted rounded-md flex items-center justify-center overflow-hidden mb-2">
                        <NuxtImg :src="item.image" :alt="item.name" width="70" height="83" class="object-contain" loading="lazy" />
                    </div>

                    <!-- Product details -->
                    <p class="text-xs font-medium text-foreground truncate">{{ item.name }}</p>
                    <div class="flex items-center gap-1 text-[10px] text-muted-foreground mb-1">
                        <span class="text-yellow-400">★</span>
                        <span class="font-semibold text-foreground">{{ item.rating }}</span>
                        <span>({{ item.reviews }})</span>
                    </div>
                    <p class="text-sm font-semibold text-foreground mb-2">${{ item.price }}</p>

                    <!-- Add to cart -->
                    <Button unstyled
                        class="w-full text-[10px] py-1.5 rounded-md bg-[#FAFAFA0A] border border-[var(--background-btn)] text-foreground font-medium">
                        ADD TO CART
                    </Button>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">

const tabs = ["Save for Later", "My List", "Gaming Setup", "Gadgets"];
const activeTab = ref("Save for Later");

const products = ref([
    {
        name: "Biker Jacket",
        price: 120.0,
        rating: 4.8,
        reviews: 229,
        image: "images/join-waitlist/jacket.png",
    },
    {
        name: "Leather Jacket",
        price: 150.0,
        rating: 4.9,
        reviews: 320,
        image: "images/join-waitlist/jacket.png",
    },
    {
        name: "Denim Jacket",
        price: 100.0,
        rating: 4.7,
        reviews: 150,
        image: "images/join-waitlist/Jacket.png",
    },
]);
</script>
